import { render, staticRenderFns } from "./WorkspaceProjectsListItem.vue?vue&type=template&id=2c08a82d&scoped=true&"
import script from "./WorkspaceProjectsListItem.vue?vue&type=script&lang=js&"
export * from "./WorkspaceProjectsListItem.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceProjectsListItem.vue?vue&type=style&index=0&id=2c08a82d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c08a82d",
  null
  
)

export default component.exports